import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M22.068 12.003a10 10 0 0 0-3.335-7.467.86.86 0 0 0-1.289.099c-.226.324-.245.747.197 1.15a8.36 8.36 0 0 1 2.755 6.218 8.314 8.314 0 0 1-6.73 8.174V18.79c0-.698-.481-.875-1.012-.501l-3.138 2.203c-.453.315-.463.787 0 1.112l3.128 2.194c.54.393 1.023.206 1.023-.502v-1.407a10.02 10.02 0 0 0 8.4-9.886M2 12.003a10 10 0 0 0 3.335 7.466.852.852 0 0 0 1.288-.108c.227-.315.246-.748-.186-1.151a8.31 8.31 0 0 1-2.765-6.207 8.314 8.314 0 0 1 6.729-8.175v1.387c0 .689.482.876 1.013.502l3.138-2.204c.453-.315.463-.787 0-1.111L11.424.198c-.541-.384-1.023-.207-1.023.502v1.416A10.02 10.02 0 0 0 2 12.003"
    }, null, -1)
  ])))
}
export default { render: render }